<div class="w-full">
  @if (label) {
  <label class="block mb-1 {{ labelCustomClass }}">{{ label }}<span class="text-red-500">*</span></label>
  }

  <!-- WRAPPER with shadow/glow; allow overflow when focused so p-password panel isn't clipped -->
  <div
    class="w-full rounded-md border border-gray-300 focus-within:border-blue-500 transition-all duration-150 shadow-none focus-within:shadow-[0_0_8px_2px_rgba(59,130,246,0.6)] overflow-hidden focus-within:overflow-visible">
    <p-password #inputRef [(ngModel)]="value" (ngModelChange)="onInput($event)" (onBlur)="onTouched()"
      [toggleMask]="true" [feedback]="showValidationHints" [disabled]="disabled" [placeholder]="placeholder"
      class="w-full text-xs !p-0" [inputStyleClass]="inputCustomClass" appendTo="body"
      [invalid]="(ngControl.invalid || ngControl.errors) && submitted" autocomplete="off">
      <ng-template #header>
        <div class="font-semibold text-xm mb-4">{{ i18n.t('password') }}</div>
      </ng-template>

      <ng-template #footer>
        <p-divider />
        <ul class="pl-2 my-0 leading-normal">
          <li>{{ i18n.t('atLeastOneLowercase') }}</li>
          <li>{{ i18n.t('atLeastOneUppercase') }}</li>
          <li>{{ i18n.t('atLeastOneNumeric') }}</li>
          <li>{{ i18n.t('minimum8Characters') }}</li>
        </ul>
      </ng-template>
    </p-password>
  </div>

  <small [appFormErrorMessageDirective]="ngControl.control" [submitted]="submitted"></small>
</div>